<template>
    <b-container fluid class="m-0 p-0 h-100 b-overlay-wrap position-relative">
        <b-row class="m-0 p-0 h-100">
            <b-col class="m-0 p-0 pr-2 col-auto">
                <b-card no-body bg-variant="white"
                        class="p-0 m-0 w-100 h-100 d-flex flex-column">
                    <b-row class="m-0 p-0 mt-1">
                        <b-col class="m-0 p-0">
                            <!--$t('PreviousYear') / Année précédente-->
                            <!--$t('PreviousMonth') / Mois précédent -->
                            <!--$t('CurrentMonth') / Mois en cours -->
                            <!--$t('NextMonth') / Mois suivant -->
                            <!--$t('NextYear') / Année suivante -->
                            <b-calendar block :value="selectedDate" :locale="language"
                                        class="border rounded p-0 m-0"
                                        label-help="" start-weekday="1"
                                        :labelPrevYear="$t('PreviousYear')" 
                                        :labelPrevMonth="$t('PreviousMonth')"
                                        :labelCurrentMonth="$t('CurrentMonth')"
                                        :labelNextMonth="$t('NextMonth')" 
                                        :labelNextYear="$t('NextYear')"
                                        :selected-variant="Variant+'-light'"
                                        :today-variant="Variant"
                                        :nav-button-variant="Variant"
                                        size="sm"
                                        @context="contextSelectedDate"
                                        :hide-header="true"/>
                        </b-col>
                    </b-row>
                    <b-row class="m-0 mt-3 p-0  h-100 mh-100 bg-white"
                           disabled="true">
                        <b-col class="m-0 p-0 ">
                            <b-card no-body
                                    class="p-0 m-0 w-100 mw-100 h-100 mh-100 col border bg-white"
                                    header-class="p-1 m-0 bg-white font-weight-bold border-bottom"
                                    :header="$tc('Factors', 2)"><!-- $t('Factors') / Facteurs d'influence -->
                                <b-row class="m-0 p-1 d-flex flex-column h-100 mh-100">
                                    <b-col class="m-0 p-0 h-100 overflow-auto">
                                        <b-list-group>
                                            <b-list-group-item href="#"
                                                               class="m-0 p-1 pl-2 border-0 rounded-0"
                                                               v-for="(factor, index) of Object.entries(FactorList)"
                                                               :key="index" button
                                                               @click="changeFactor(factor[0])"
                                                               :active="selectedFactor != undefined && selectedFactor != null ? false : selectedFactor?.Id == factor[0]"
                                                               :class="selectedFactor != undefined && selectedFactor != null && selectedFactor?.Id == factor[0] ? 'text-' + Variant +
                                                                                ' bg-'+Variant+'-light' : ''"
                                                               variant="white">
                                                <b-row class="m-0 p-0">
                                                    <b-col class="m-0 p-0">
                                                        <font-awesome-icon v-if="factor[1].HasData"
                                                                           icon="circle-check"
                                                                           v-b-tooltip.hover="$t('CurrentData')" 
                                                                           :class="'p-0 position-absolute text-' + Variant"
                                                                           style="height:10px;width:10px;top:0;left:-5px;"/>
                                                        <span class="m-0 p-0" style="padding-left:8px !important;">
                                                          {{ factor[1].Label }} ({{ factor[1].Unit }})
                                                        </span>
                                                        <!--<b-icon v-if="factor.HasData"
                                                                icon="circle-fill"
                                                                class="factorHasData"
                                                                v-b-tooltip="'Présence de données'">
                                                        </b-icon>-->
                                                    </b-col>
                                                    <b-col class="m-0 p-0 pr-1" md="auto">
                                                        <b-icon
                                                            v-if="selectedFactor != undefined && selectedFactor != null && selectedFactor?.Id == factor[0]"
                                                            icon="check2">
                                                        </b-icon>
                                                    </b-col>
                                                </b-row>
                                            </b-list-group-item>
                                        </b-list-group>
                                    </b-col>
                                </b-row>
                            </b-card>
                        </b-col>
                    </b-row>
                    <b-row class="m-0 p-0 mt-3 mb-1">
                        <b-col class="m-0 p-0 h-100 mh-100">
                            <b-card no-body border-variant="light" bg-variant="white"
                                    class="p-0 m-0 w-100 mw-100 h-100 mh-100 col border"
                                    header-class="p-1 m-0 font-weight-bold">
                                <b-list-group class="m-0 p-1">
                                    <b-list-group-item class="m-0 p-1 border-0 rounded-0">
                                        <b-badge variant="tertiary" class="mr-1 rounded-0">
                                            &nbsp;&nbsp;
                                        </b-badge>
                                        {{ $t('CalculatedValue') }}
                                    </b-list-group-item>  <!-- Toujours -->
                                    <b-list-group-item class="m-0 p-1 border-0 rounded-0"
                                                       v-if="selectedFactor != undefined && selectedFactor != null && selectedFactor.FactorType != 2">
                                        <b-badge variant="quartary" class="mr-1 rounded-0">
                                            &nbsp;&nbsp;
                                        </b-badge>
                                        {{ $t('TypeTotalValue') }}
                                    </b-list-group-item> <!-- Type != Moyenne -->
                                    <b-list-group-item class="m-0 p-1 border-0 rounded-0"
                                                       v-if="selectedFactor != undefined && selectedFactor != null && selectedFactor.FactorType != 2">
                                        <b-badge variant="secondary-middle-light" class="mr-1 rounded-0">
                                            &nbsp;&nbsp;
                                        </b-badge>
                                        {{ $t('TypeAverageDayValue') }}
                                    </b-list-group-item><!-- Type != Moyenne -->
                                    <b-list-group-item class="m-0 p-1 border-0 rounded-0"
                                                       v-if="selectedFactor != undefined && selectedFactor != null && selectedFactor.FactorType != 2">
                                        <b-badge variant="secondary-dark" class="mr-1 rounded-0">
                                            &nbsp;&nbsp;
                                        </b-badge>
                                        {{ $t('TypeAverageHourValue') }}
                                    </b-list-group-item><!-- Type != Moyenne -->
                                    <b-list-group-item class="m-0 p-1 border-0 rounded-0"
                                                       v-if="selectedFactor != undefined && selectedFactor != null && selectedFactor.FactorType != 2">
                                        <b-badge variant="secondary" class="mr-1 rounded-0">
                                            &nbsp;&nbsp;
                                        </b-badge>
                                        {{ $t('TypeAverageMinuteValue') }}
                                    </b-list-group-item><!-- Type != Moyenne -->
                                    <b-list-group-item class="m-0 p-1 border-0 rounded-0"
                                                       v-if="selectedFactor != undefined && selectedFactor != null && selectedFactor.FactorType == 2">
                                        <b-badge variant="primary" class="mr-1 rounded-0">
                                            &nbsp;&nbsp;
                                        </b-badge>
                                        {{ $t('AverageValue') }}
                                    </b-list-group-item> <!-- Type = Moyenne  -->
                                </b-list-group>
                            </b-card>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
            <b-col class="m-0 p-0 d-flex flex-column h-100 mh-100">
                <b-row class="m-0 p-0">
                    <b-col class="m-0 p-0 pt-1 col-md-auto">
                        <b-button-group size="sm"
                                        class="m-1 btn-gray-light rounded-pill border border-gray">
                            <b-button :pressed="calendarType == factorCalendarTypeEnum.Semester" v-b-tooltip.hover
                                      @click="calendarType = factorCalendarTypeEnum.Semester" pill
                                      :class="calendarType == factorCalendarTypeEnum.Semester? 'bg-white text-'+Variant :''"
                                      :variant="'outline-white'">
                                {{ $t('Semester') }}
                            </b-button>
                            <b-button :pressed="calendarType == 'month'" v-b-tooltip.hover
                                      @click="calendarType = factorCalendarTypeEnum.Month" pill
                                      :class="calendarType == factorCalendarTypeEnum.Month? 'bg-white text-'+Variant :''"
                                      variant="outline-white">
                                {{ $t('Month') }}
                            </b-button>
                            <b-button :pressed="calendarType == factorCalendarTypeEnum.Week" v-b-tooltip.hover
                                      @click="calendarType = factorCalendarTypeEnum.Week" pill
                                      :class="calendarType == factorCalendarTypeEnum.Week ? 'bg-white text-'+Variant :''"
                                      variant="outline-white">
                                {{ $t('Week') }}
                            </b-button>
                            <b-button :pressed="calendarType == factorCalendarTypeEnum.Day" v-b-tooltip.hover
                                      @click="calendarType = factorCalendarTypeEnum.Day" pill
                                      :class="calendarType == factorCalendarTypeEnum.Day? 'bg-white text-'+Variant :''"
                                      variant="outline-white">
                                {{ $t('Day') }}
                            </b-button>
                        </b-button-group>
                    </b-col>
                    <!-- Affichage de la date sélectionnée en fonction du type de calendrier -->
                    <b-col class="p-0 pt-1 m-0 text-center">
                        <b-button v-b-tooltip.hover :title="$t('Previous')"
                                  class="m-0 my-1 btn-circle border-0" size="sm"
                                  variant="outline-gray-dark"
                                  pill @click="goToNextDate(-1)">
                            <b-icon icon="chevron-left"/>
                        </b-button>
                        <b>{{ labelSelectedDate }}</b>
                        <b-button v-b-tooltip.hover :title="$t('Next')"
                                  class="m-0 my-1 border-0 btn-circle" size="sm"
                                  variant="outline-gray-dark"
                                  pill @click="goToNextDate(1)">
                            <b-icon icon="chevron-right"/>
                        </b-button>
                    </b-col>
                    <!-- Ajout d'une nouvelle donnée -->
                    <b-col md="auto" class="m-0 p-0 mt-2">
                        <b-button v-b-tooltip.hover :title="$t('AddValue')" v-if="selectedFactor != undefined && selectedFactor != null"
                                  :variant="'outline-'+ Variant" @click.stop="clickAdd"
                                  :disabled="!$store.getters['CheckAction']('Add', undefined, Action)"
                                  class="m-0 my-1 btn-circle-small">
                            <b-icon icon="plus" />
                        </b-button>
                    </b-col>
                    <!-- Enregistrement dans la visualisation de l'administration -->
                    <b-col md="auto" class="m-0 p-0 pt-1">
                        <b-button @click="save()" v-b-tooltip.hover :title="$t('Save1')"
                                  v-if="selectedFactor != undefined && selectedFactor != null && !NodeId && $store.getters['CheckAction']('Write', undefined, Action)"
                                  pill  class="m-1 mr-0 mt-2 btn-circle-small" size="sm"
                                  :variant="Variant">
                            <b-icon v-if="haveToSave" v-b-tooltip.noninteractive.hover icon="exclamation-circle-fill"
                                    class="position-absolute top-0 end-0 translate-middle rounded-pill text-info"
                                    shift-v="8"
                                    style="z-index:1 !important"/>
                            <i class="bi-floppy"/>
                        </b-button>
                    </b-col>
                    <!-- Partie Export -->
                    <b-col md="auto" class="m-0 p-1 pt-2">
                        <b-button @click="exportExcel()" v-b-tooltip.hover :title="$t('ExcelExport')" disabled
                                  class="m-0 my-1 border-0 btn-circle-small" pill v-if="selectedFactor != undefined && selectedFactor != null"
                                  :variant="'outline-' + Variant">
                            <b-icon icon="file-earmark-excel"/>
                        </b-button>
                    </b-col>
                    <!-- Partie Valeurs minimum et maximum -->
                    <b-col md="auto" class="m-0 p-0 pt-1 ml-2 align-items-center" v-if="selectedFactor != undefined && selectedFactor != null">
                        <b-badge class="my-2 ml-0 mr-1 p-2 font-weight-normal border border-gray-dark" variant="light">
                            {{ $t('Mini') }} <b>{{ minValue != undefined && isFinite(minValue) ? Intl.NumberFormat('fr-FR').format(minValue) : '' }}</b>
                        </b-badge>
                    </b-col>
                    <b-col md="auto" class="m-0 p-0 pt-1" v-if="selectedFactor != undefined && selectedFactor != null">
                        <b-badge class="my-2 ml-0 mr-1 p-2 font-weight-normal border border-gray-dark" variant="light">
                            {{ $t('Maxi') }} <b>{{ maxValue != undefined && isFinite(maxValue) ? Intl.NumberFormat('fr-FR').format(maxValue) : '' }}</b>
                        </b-badge>
                    </b-col>
                </b-row>
                <!-- Partie calendrier -->
                <b-row class="m-0 p-0 flex-grow-1">
                    <b-col class="m-0 px-1 pt-0 pb-1">
                        <FactorCalendar :Data="data" :OuterData="outerData"
                                        :CalendarType="calendarType ?? factorCalendarTypeEnum.Semester"
                                        :SelectedDate="selectedDate" :Variant="Variant"
                                        :HaveToSave="haveToSave" :SelectedFactor="selectedFactor"
                                        :StartPeriod.sync="startPeriod" :EndPeriod.sync="endPeriod"
                                        :ShowModal.sync="showModal" :ShowDatas.sync="showDatas"
                                        @emitSave="saveValue"
                                        :Action="Action"/>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-container>
</template>

<script lang="ts">

import {Component, Prop, PropSync, Vue, Watch} from "vue-property-decorator";
import moment from "moment";
import FactorCalendar from "@/components/commons/Factors/FactorCalendar.vue";
import FactorField from "@/types/fields/FactorField";
import Dictionary from "@/types/Dictionary";
import axios from "axios";
import {API_URL} from "@/App.settings";
import Multiselect from 'vue-multiselect';
import {mixins} from "vue-class-component";
import {FactorUtils} from "@/components/commons/Factors/FactorUtils";
import FactorCalendarMonth from "@/components/commons/Factors/FactorCalendarMonth.vue";
import FactorCalendarTypeEnum from "@/enums/FactorCalendarTypeEnum";
import locales from './locales/FactorsEntering.json';
import { Getter } from "vuex-class";

/** Composant  */
@Component({
    methods: {},
    components: {
        FactorCalendarMonth,
        Multiselect,
        FactorCalendar,
        FactorField
    },
    i18n:{messages : locales}
})
export default class FactorsEntering extends mixins(Vue, FactorUtils) {
    @Prop({default: () => 'secondary'})
    public Variant!: string;

    @Getter('SessionStore/GetLanguage')
    private language!: string;

    /** Droit disponible pour l'utilisateur en cours */
    @Prop()
    public Action!: string;

    /** Nœud */
    @Prop({default: () => ""})
    public NodeId!: String;

    /** Liste des facteurs d'influence */
    @Prop({default: () => []})
    public FactorList!: Dictionary<FactorField>;

    @PropSync("HaveToSave", {default: () => false})
    public haveToSave: boolean
    private saveFactorChange?: { factorId: number, modifData: any[] }[] = [];

    private createdPage: boolean = false;

    /** Pour accéder à l'enum dans la partie template */
    private factorCalendarTypeEnum = FactorCalendarTypeEnum;

    /** Date de selection */
    private selectedDate: Date = new Date(Date.now());
    private labelSelectedDate: string = '';
    /** Type de calendrier */
    private calendarType: FactorCalendarTypeEnum = FactorCalendarTypeEnum.Semester;
    /** Valeur Min et Max */
    private maxValue?: number = null;
    private minValue?: number = null;
    /** Données du facteur d'influence pour ce nœud */
    private data: any[] = [];
    /** Premières Données du facteur en dehors de la période */
    private outerData: any[] = [];
    /** facteur sélectionné **/
    public selectedFactor?: {
        Label: string, Id: number,
        CumulNode: boolean, IsGlobal: boolean, IsStatic: boolean, Unit: string, FactorType: number,
        HasData: boolean, Temporality: number
    } = null;

    private startPeriod: moment.Moment = moment();
    private endPeriod: moment.Moment = moment();

    private showModal: boolean = false;
    private showDatas: {
        NoMonth: number, NoDay: number, Status: number, DataId?: number, StartDate?: string,
        StartTime?: string, EndDate?: string, EndTime?: string, Periodicity?: number,
        Value?: number, Unit: string, Collapsed: boolean, StartNoDay: number; EndNoDay: number,
        StartNoHour: number; EndNoHour: number
    } [] = [];

    public created() {
        console.debug('FactorsEntering.vue - created', this.selectedFactor, this.selectedDate, this.calendarType);
        this.createdPage = true;
        console.debug('FactorsEntering.vue - created - Fin');
    }

    public contextSelectedDate(date) {
        console.debug('FactorsEntering.vue - contextSelectedDate');
        this.selectedDate = date?.selectedDate;

        /** Au chargement les données modifiées seront réinjectées dans la procédure stockée. */
    }

    //#region Données des facteurs

    @Watch('FactorList', {immediate: true})
    public refreshFactorList() {
        if (this.FactorList != undefined) {
            let key = Object.keys(this.FactorList);
            console.debug('FactorsEntering.vue - refreshFactorList', this.FactorList, key, key.length);
            if (key.length > 0) {
                this.changeFactor(parseInt(Object.keys(this.FactorList)[0]));
                console.debug('FactorsEntering.vue - refreshFactorList', this.selectedFactor, this.selectedDate, this.calendarType, this.FactorList, parseInt(Object.keys(this.FactorList)[0]));
            }
        }
    }

    @Watch('NodeId', {immediate: true})
    @Watch('selectedFactor', {immediate: true})
    @Watch('selectedDate', {immediate: true})
    @Watch('calendarType', {immediate: true})
    @Watch('tabIndex', {immediate: true})
    public refreshFactorData(oldValue, newValue) {
        console.debug("FactorsEntering.vue - refreshFactorData", this.selectedFactor, this.selectedDate,
            this.calendarType, oldValue, newValue, "condition d'exécution",
            newValue != undefined &&
            (((oldValue instanceof Date) && oldValue?.getTime() != newValue?.getTime()) || !(oldValue instanceof Date)));
        if (newValue != undefined &&
            (((oldValue instanceof Date) && oldValue?.getTime() != newValue?.getTime()) || !(oldValue instanceof Date)))
            this.getFactorData(this.selectedFactor, this.selectedDate, this.calendarType, this.NodeId);
    }

    /**
     * Ajout d'une donnée à partir du bouton
     */
    public clickAdd(){
        this.showDatas = [];
        let dataId = Math.abs(Math.min(...this.data.map(a=> a.ids).flat())) ;
        if (dataId ==  Infinity || isNaN(dataId)) {
            dataId = 0;
        }
        this.showDatas.push({
            NoMonth: 1,
            NoDay: 0,
            Status: 0,
            DataId: dataId * (-1) - 1,
            StartDate: undefined,
            StartTime: undefined,
            EndDate: undefined,
            EndTime: undefined,
            Periodicity: 0,
            Value: undefined,
            Unit: this.selectedFactor?.Unit,
            Collapsed: true,
            StartNoDay: 0,
            EndNoDay: 0,
            StartNoHour: 0,
            EndNoHour: 0,
        });
        Vue.set(this,'showModal',this.selectedFactor.Temporality == 1 /* Limited */);

        if (this.selectedFactor.Temporality != 1 /* Limited */){
            this.$bvToast.toast(this.$t('NotYetPossibleModifyFactor').toString(), { // $t('NotYetPossibleModifyFactor') / Il n'est pas encore possible de modifier des facteurs de type indexés ou instantanés.
                title: this.$t('ImpossibleAction').toString(), // $t('ImpossibleAction') / "Action impossible"
                autoHideDelay: 10000,
                variant: "danger",
                solid: true,
                appendToast: true,
                toaster: "b-toaster-top-center"
            });
        }
    }

    /**
     * Lors du changement de periode par les bouton au tour du libelle
     * @param way
     */
    public goToNextDate(way: number = 1) {
        console.debug('FactorsEntering.vue - goToNextDate');

        switch (this.calendarType) {
            case FactorCalendarTypeEnum.Semester:
            case FactorCalendarTypeEnum.Month:
                this.selectedDate = moment(this.selectedDate).clone().add(way, 'month').toDate();
                break;
            case FactorCalendarTypeEnum.Week:
                this.selectedDate = moment(this.selectedDate).clone().add(way * 7, 'day').toDate();
                break;
            case FactorCalendarTypeEnum.Day:
                this.selectedDate = moment(this.selectedDate).clone().add(way, 'day').toDate();
                break;
        }

        /** Au chargement les données modifiées seront réinjectées dans la procédure stockée. */
    }

    /**
     * Suite à la modification d'une donnée d'un facteur d'influence
     * @param values
     * @private
     */
    private saveValue(values) {
        console.debug('FactorsEntering.vue - saveValue - values : %O', values);

        this.$store.dispatch("ShowLoadingMask", "Application en cours");

        let updateDatas = true;
        for (let i = 0; i < values.length; i++) {
            let value = values[i];
            console.debug('FactorsEntering.vue - saveValue - value : %O', value);

            /* Recherche de la date de début de traitement */
            let dataDayIndex = -1;
            if (value.DataId != undefined && value.DataId > -1) {
                dataDayIndex = this.data.findIndex(a => a.values.findIndex(b=> b.endData.id == value.DataId ||
                    b.startData.id == value.DataId) > -1);
            }
            else {
                let noDay = value.NoDay;
                let startPeriodNoDay = this.startPeriod.year() * 10000 + (this.startPeriod.month() + 1) * 100
                    + this.startPeriod.date();
                if (startPeriodNoDay > value.StartNoDay){
                    noDay = startPeriodNoDay;
                }
                dataDayIndex = this.data.findIndex(a => a.noDay == noDay);
                // Dans le cas de la gestion de l'heure
                if (this.data[0].noHour != 0) {
                    dataDayIndex = this.data.findIndex(a => a.noHour == value.StartNoHour);
                }
            }
            console.debug('FactorsEntering.vue - saveValue - dataDayIndex : %O', dataDayIndex);

            if (dataDayIndex > -1){
                // jour/heure trouvé
                switch (this.selectedFactor?.Temporality) {
                    case 1:
                        updateDatas = this.saveLimitedValue(value, dataDayIndex);
                        break;
                    case 2:
                        updateDatas = this.saveInstantValue(value, dataDayIndex);
                        break;
                    case 3:
                        updateDatas = this.saveIndexedValue(value, dataDayIndex);
                        break;
                }

                /** Dans le cas où la valeur a été prise en compte */
                if (updateDatas) {
                    /** Recalcule des pourcentages */
                    let maxValueAbs = Math.max(...this.data.flatMap(a => a.values).map(a => Math.abs(a.value)));
                    for (let noDay = 0; noDay < this.data.length; noDay++) {
                        for (let noValue = 0; noValue < this.data[noDay].values.length; noValue++) {
                            if (this.data[noDay].values[noValue] != undefined)
                                this.data[noDay].values[noValue].valuePourcent = Math.abs(this.data[noDay].values[noValue].value) * 100 / maxValueAbs;
                        }
                    }

                    /** Re-affichage de la valeur minimum et maximum */
                    let minMax = this.getMinMax({data: this.data, outerData: this.outerData}, this.startPeriod, this.endPeriod);
                    this.minValue = minMax.min;
                    this.maxValue = minMax.max;

                    /** Sauvegarde du changement de la valeur */
                    if (!('Value' in this.FactorList[this.selectedFactor.Id])){
                        this.FactorList[this.selectedFactor.Id].Value = [];
                    }
                    this.FactorList[this.selectedFactor.Id].Value.push({
                        Status: value.Status,
                        DataId: value.DataId,
                        StartDate: value.StartDate == undefined || value.StartDate == '0001-01-01' ? undefined : new Date(value.StartDate + 'T' + value.StartTime + 'Z').toISOString(),
                        EndDate: value.EndDate == undefined || value.EndDate == '9999-12-31' ? undefined : new Date(value.EndDate + 'T' + value.EndTime + 'Z').toISOString(),
                        Periodicity: value.Periodicity,
                        Value: value.Value,
                    });
                }
            }
            else {
                this.$bvToast.toast(this.$t('YearNotDefined').toString() // $t('YearNotDefined') / Ce jour n'est pas défini dans le périmètre (Erreur : 
                    + value.NoDay + ").", {
                    title: this.$t('Error').toString(), // $t('Error') / "Erreur"
                    autoHideDelay: 10000,
                    variant: "danger",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });
            }

        }
        this.haveToSave = updateDatas;

        this.$store.dispatch("HideLoadingMask", {});
    }

    /**
     * Traitement d'une valeur bornée
     * // TODO : Problème lors du changement de borne si -infini et +infini
     * @param value
     * @param startDataIndex Index du jour de début de la période
     * @private
     */
    private saveLimitedValue(value, startDataIndex): boolean {
        let updateDatas = true;
        switch (value.Status) {
            case -1:
                /** Suppression de la valeur */
                if (this.calendarType == FactorCalendarTypeEnum.Semester) {
                    //let ids = this.data.map(a=> a.ids) -- à revoir ...
                    let valueInCalculate = this.data.filter(a => a.ids.includes(value.DataId)).filter(a => a.isCalculate);
                    if (valueInCalculate.length > 0) {
                        updateDatas = false;
                        this.$bvToast.toast(this.$t('DeleteErrorMessage').toString(), { //$t('DeleteErrorMessage') / Il est impossible de supprimer la valeur en mode Semestre. Celle-ci est utilisée pour une valeur calculée. Veuillez sélectionner un autre mode d'affichage.
                            title: this.$t('UnableToDelete').toString(), // $t('UnableToDelete') / "Suppression impossible"
                            autoHideDelay: 10000,
                            variant: "warning",
                            solid: true,
                            appendToast: true,
                            toaster: "b-toaster-top-center"
                        });
                    }
                }

                if (updateDatas) {
                    for (let date = 0; date < this.data.length; date++) {
                        /* Recherche de la valeur en question sur toutes les dates de la période */
                        let startValueIndex = this.data[date].values.findIndex((a) => a.startData.id == value.DataId);
                        if (startValueIndex != -1) {
                            /* Suppression de la valeur trouvée */
                            this.data[date].values.splice(startValueIndex, 1);
                        }
                    }
                }
                break;
            case 0:
                /** Ajout d'une nouvelle valeur */
                let datas = this.data.filter(a => value.StartNoDay <= a.noDay && a.noDay <= value.EndNoDay);
                console.debug('FactorsEntering.vue - saveTemporalityValue - datas : %O - value : %O', datas, value);
                if (this.calendarType == FactorCalendarTypeEnum.Semester) {
                    if (datas != undefined && datas.length > 0 && datas.findIndex(a => a.isCalculate) > -1) {
                        // La période contient déjà plusieurs valeurs, l'ajout de valeur est interdite
                        updateDatas = false;
                        this.$bvToast.toast(this.$t('AddErrorMessage').toString(), { // $t('AddErrorMessage') / Il est impossible d'ajouter la valeur en mode Semestre. La période contient déjà plusieurs valeurs dont des valeurs calculées. Veuillez sélectionner un autre mode d'affichage.
                            title: this.$t('UnableToAdd').toString(), // $t('UnableToAdd') / UnableToAdd
                            autoHideDelay: 10000,
                            variant: "warning",
                            solid: true,
                            appendToast: true,
                            toaster: "b-toaster-top-center"
                        });
                    }
                }
                // Vérification de la présence de valeur sur cette période
                else if (datas != undefined && datas.length > 1) {
                    // La période de la nouvelle valeur est sur plusieurs jours.
                    if (datas.slice(1, -1).findIndex(a => a.ids.length > 0) > -1) {
                        updateDatas = false;
                        this.$bvToast.toast(this.$t('PeriodAlreadyContainsValues').toString(), { // $t('PeriodAlreadyContainsValues') / La période contient déjà des valeurs.
                            title: this.$t('UnableToAdd').toString(), // $t('UnableToAdd') / "Ajout impossible"
                            autoHideDelay: 10000,
                            variant: "warning",
                            solid: true,
                            appendToast: true,
                            toaster: "b-toaster-top-center"
                        });
                    } else {
                        let first = datas[0];
                        let last = datas[datas.length - 1];
                        if (first.values.length > 0) {
                            // La date de début de la période doit être supérieure à la dernière date de valeur déjà définie.
                            let endDate = moment(new Date(first.values[0].endData.date));
                            let endNoHour = endDate.year() * 100000000 + (endDate.month() + 1) * 1000000 + endDate.date() * 10000
                                + endDate.hours() * 100 + endDate.minutes();
                            if (endNoHour > value.StartNoHour) {
                                updateDatas = false;
                                this.$bvToast.toast(this.$t('PeriodAlreadyContainsValues').toString(), { // $t('PeriodAlreadyContainsValues') / La période contient déjà des valeurs.
                                    title: this.$t('UnableToAdd').toString(), // $t('UnableToAdd') / "Ajout impossible"
                                    autoHideDelay: 10000,
                                    variant: "warning",
                                    solid: true,
                                    appendToast: true,
                                    toaster: "b-toaster-top-center"
                                });
                            }
                        } else if (last.values.length > 0) {
                            // La date de fin de la période doit être inférieure à la première date de valeur déjà définie.
                            let startDate = moment(new Date(last.values[0].startData.date));
                            let startNoHour = startDate.year() * 100000000 + (startDate.month() + 1) * 1000000 + startDate.date() * 10000
                                + startDate.hours() * 100 + startDate.minutes();
                            if (startNoHour < value.EndNoHour) {
                                updateDatas = false;
                                this.$bvToast.toast(this.$t('PeriodAlreadyContainsValues').toString(), { // $t('PeriodAlreadyContainsValues') / La période contient déjà des valeurs.
                                    title: this.$t('UnableToAdd').toString(), // $t('UnableToAdd') / "Ajout impossible"
                                    autoHideDelay: 10000,
                                    variant: "warning",
                                    solid: true,
                                    appendToast: true,
                                    toaster: "b-toaster-top-center"
                                });
                            }
                        }
                    }
                }
                if (updateDatas && this.outerData.length > 0) {
                    let start: number = undefined;
                    let end: number = undefined;
                    for (let i = 0; i < this.outerData.length; i++) {
                        let dateOuter = moment(new Date(this.outerData[i].date));
                        if (dateOuter <= this.startPeriod) {
                            start = dateOuter.year() * 100000000 + (dateOuter.month() + 1) * 1000000 + dateOuter.date() * 10000
                                + dateOuter.hours() * 100 + dateOuter.minutes();
                        }
                        if (dateOuter >= this.endPeriod) {
                            end = dateOuter.year() * 100000000 + (dateOuter.month() + 1) * 1000000 + dateOuter.date() * 10000
                                + dateOuter.hours() * 100 + dateOuter.minutes();
                        }
                    }
                    console.debug('FactorsEntering.vue - saveTemporalityValue - start : %O - end : %O', start, end,
                        value.StartNoHour, value.EndNoHour);
                    if (start != undefined && start > value.StartNoHour) {
                        updateDatas = false;
                        this.$bvToast.toast(this.$t('PeriodAlreadyContainsValues').toString(), { // $t('PeriodAlreadyContainsValues') / La période contient déjà des valeurs.
                            title: this.$t('UnableToAdd').toString(), // $t('UnableToAdd') / "Ajout impossible"
                            autoHideDelay: 10000,
                            variant: "warning",
                            solid: true,
                            appendToast: true,
                            toaster: "b-toaster-top-center"
                        });
                    } else if (end != undefined && end < value.EndNoHour) {
                        updateDatas = false;
                        this.$bvToast.toast(this.$t('PeriodAlreadyContainsValues').toString(), { // $t('PeriodAlreadyContainsValues') / La période contient déjà des valeurs.
                            title: this.$t('UnableToAdd').toString(), // $t('UnableToAdd') / "Ajout impossible"
                            autoHideDelay: 10000,
                            variant: "warning",
                            solid: true,
                            appendToast: true,
                            toaster: "b-toaster-top-center"
                        });
                    }
                }

                if (updateDatas) {
                    // Calcul de l'index du jour de fin
                    let endDataIndex = -1;
                    let noDay = value.EndNoDay;
                    let endPeriodNoDay = this.endPeriod.year() * 10000 + (this.endPeriod.month() + 1) * 100
                        + this.endPeriod.date();
                    if (endPeriodNoDay < noDay) {
                        noDay = endPeriodNoDay;
                    }
                    endDataIndex = this.data.findIndex(a => a.noDay == noDay);
                    // Dans le cas de la gestion de l'heure
                    if (this.data[0].noHour != 0) {
                        endDataIndex = this.data.findIndex(a => a.noHour == value.EndNoHour);
                    }

                    let startDate = this.getMomentDate(value.StartDate + ' ' + value.StartTime);
                    let startDateMoment = moment(startDate);
                    let endDate = this.getMomentDate(value.EndDate + ' ' + value.EndTime);
                    let endDateMoment = moment(endDate);
                    if (endDateMoment.hours() * 100 + endDateMoment.minutes() == 0) {
                        endDateMoment.subtract({days: -1});
                    }
                    let startMinutesValue = startDate.minutes() + startDate.hours() * 60;

                    // Ajout de la valeur sur la période
                    for (let i = startDataIndex; i <= endDataIndex; i++) {
                        this.data[i].ids.push(value.DataId);
                        this.data[i].values.push({
                            endData: {
                                date: endDate,
                                id: value.DataId,
                                noDay: endDateMoment.year() * 10000 + (endDateMoment.month() + 1) * 100 + endDateMoment.date(),
                                noMonth: endDateMoment.year() * 100 + (endDateMoment.month() + 1),
                                value: parseFloat(value.Value)
                            },
                            isFadeIn: 1,
                            isFadeOut: 1,
                            lenghtMinutesValue: 0,
                            periodicity: value.Periodicity,
                            startData: {
                                date: startDate,
                                id: value.DataId,
                                noDay: startDateMoment.year() * 10000 + (startDateMoment.month() + 1) * 100 + startDateMoment.date(),
                                noMonth: startDateMoment.year() * 100 + (startDateMoment.month() + 1),
                                value: parseFloat(value.Value)
                            },
                            startMinutesValue: i == startDataIndex ? startMinutesValue : 0,
                            unit: value.Unit,
                            value: parseFloat(value.Value),
                            valuePourcent: 0,
                            nbPeriodValue: 1,
                        });
                        this.data[i].values[this.data[i].values.length - 1] =
                            this.calculValue(this.data[i].values[this.data[i].values.length - 1], this.data[i].noDay);

                        if (this.data[i].values.length > 0) {
                            Vue.set(this.data, i, this.calculValueDay(this.data[i]));
                        }
                    }
                }
                break;
            case 1:
                /** Modification de la valeur ou de la période */
                let datas1 = this.data.filter(a => value.StartNoDay <= a.noDay && a.noDay <= value.EndNoDay);
                console.debug('FactorsEntering.vue - saveTemporalityValue - datas : %O - value : %O', datas1, value);
                if (this.calendarType == FactorCalendarTypeEnum.Semester) {
                    if (datas1 != undefined && datas1.length > 0 && datas1.findIndex(a => a.isCalculate) > -1) {
                        // La période contient déjà plusieurs valeurs, l'ajout de valeur est interdite
                        updateDatas = false;
                        this.$bvToast.toast(this.$t('AddErrorMessage').toString(), { // $t('AddErrorMessage') / Il est impossible d'ajouter la valeur en mode Semestre. La période contient déjà plusieurs valeurs dont des valeurs calculées. Veuillez sélectionner un autre mode d'affichage.
                            title: this.$t('UnableToAdd').toString(), // $t('UnableToAdd') / "Ajout impossible"
                            autoHideDelay: 10000,
                            variant: "warning",
                            solid: true,
                            appendToast: true,
                            toaster: "b-toaster-top-center"
                        });
                    }
                }
                // Vérification de la présence de valeur sur cette période
                else if (datas1 != undefined && datas1.length > 1) {
                    // La période de la nouvelle valeur est sur plusieurs jours.
                    if (datas1.slice(1, -1).findIndex(a => a.ids.filter(d => d != value.DataId).length > 0) > -1) {
                        updateDatas = false;
                        this.$bvToast.toast(this.$t('PeriodAlreadyContainsValues').toString(), { // $t('PeriodAlreadyContainsValues' / "La période contient déjà des valeurs.", {
                            title: this.$t('UnableToAdd').toString(), // $t('UnableToAdd') / "Ajout impossible"
                            autoHideDelay: 10000,
                            variant: "warning",
                            solid: true,
                            appendToast: true,
                            toaster: "b-toaster-top-center"
                        });
                    } else {
                        let first = datas1[0];
                        let last = datas1[datas1.length - 1];
                        if (first.values.filter(d => d.startData.id != value.DataId || d.endData.id != value.DataId).length > 0) {
                            // La date de début de la période doit être supérieure à la dernière date de valeur déjà définie.
                            let endDate = moment(new Date(first.values[0].endData.date));
                            let endNoHour = endDate.year() * 100000000 + (endDate.month() + 1) * 1000000 + endDate.date() * 10000
                                + endDate.hours() * 100 + endDate.minutes();
                            if (endNoHour > value.StartNoHour) {
                                updateDatas = false;
                                this.$bvToast.toast(this.$t('PeriodAlreadyContainsValues').toString(), { // $t('PeriodAlreadyContainsValues' / "La période contient déjà des valeurs.", {
                                    title: this.$t('UnableToAdd').toString(), // $t('UnableToAdd') / "Ajout impossible"
                                    autoHideDelay: 10000,
                                    variant: "warning",
                                    solid: true,
                                    appendToast: true,
                                    toaster: "b-toaster-top-center"
                                });
                            }
                        } else if (last.values.filter(d => d.startData.id != value.DataId || d.endData.id != value.DataId).length > 0) {
                            // La date de fin de la période doit être inférieure à la première date de valeur déjà définie.
                            let startDate = moment(new Date(last.values[0].startData.date));
                            let startNoHour = startDate.year() * 100000000 + (startDate.month() + 1) * 1000000 + startDate.date() * 10000
                                + startDate.hours() * 100 + startDate.minutes();
                            if (startNoHour < value.EndNoHour) {
                                updateDatas = false;
                                this.$bvToast.toast(this.$t('PeriodAlreadyContainsValues').toString(), { // $t('PeriodAlreadyContainsValues' / "La période contient déjà des valeurs.", {
                                    title: this.$t('UnableToAdd').toString(), // $t('UnableToAdd') / "Ajout impossible"
                                    autoHideDelay: 10000,
                                    variant: "warning",
                                    solid: true,
                                    appendToast: true,
                                    toaster: "b-toaster-top-center"
                                });
                            }
                        }
                    }
                }
                if (updateDatas && this.outerData.length > 0) {
                    let start: number = undefined;
                    let end: number = undefined;
                    for (let i = 0; i < this.outerData.length; i++) {
                        let dateOuter = moment(new Date(this.outerData[i].date));
                        if (dateOuter <= this.startPeriod) {
                            start = dateOuter.year() * 100000000 + (dateOuter.month() + 1) * 1000000 + dateOuter.date() * 10000
                                + dateOuter.hours() * 100 + dateOuter.minutes();
                        }
                        if (dateOuter >= this.endPeriod) {
                            end = dateOuter.year() * 100000000 + (dateOuter.month() + 1) * 1000000 + dateOuter.date() * 10000
                                + dateOuter.hours() * 100 + dateOuter.minutes();
                        }
                    }
                    console.debug('FactorsEntering.vue - saveTemporalityValue - start : %O - end : %O', start, end,
                        value.StartNoHour, value.EndNoHour);
                    if (start != undefined && start > value.StartNoHour) {
                        updateDatas = false;
                        this.$bvToast.toast(this.$t('PeriodAlreadyContainsValues').toString(), { // $t('PeriodAlreadyContainsValues' / "La période contient déjà des valeurs.", {
                            title: this.$t('UnableToAdd').toString(), // $t('UnableToAdd') / "Ajout impossible"
                            autoHideDelay: 10000,
                            variant: "warning",
                            solid: true,
                            appendToast: true,
                            toaster: "b-toaster-top-center"
                        });
                    } else if (end != undefined && end < value.EndNoHour) {
                        updateDatas = false;
                        this.$bvToast.toast(this.$t('PeriodAlreadyContainsValues').toString(), { // $t('PeriodAlreadyContainsValues' / "La période contient déjà des valeurs.", {
                            title: this.$t('UnableToAdd').toString(), // $t('UnableToAdd') / "Ajout impossible"
                            autoHideDelay: 10000,
                            variant: "warning",
                            solid: true,
                            appendToast: true,
                            toaster: "b-toaster-top-center"
                        });
                    }
                }

                if (updateDatas) {
                    // Calcul de l'index du jour de fin
                    let endDataIndex = -1;
                    let noDay = value.EndNoDay;
                    let endPeriodNoDay = this.endPeriod.year() * 10000 + (this.endPeriod.month() + 1) * 100
                        + this.endPeriod.date();
                    endDataIndex = this.data.findIndex(a => a.noDay == noDay);
                    // Dans le cas de la gestion de l'heure
                    if (this.data[0].noHour != 0) {
                        endDataIndex = this.data.findIndex(a => a.noHour == value.EndNoHour);
                    }

                    let startDate = this.getMomentDate(value.StartDate + ' ' + value.StartTime);
                    let startDateMoment = moment(startDate);
                    let endDate = this.getMomentDate(value.EndDate + ' ' + value.EndTime);
                    let endDateMoment = moment(endDate);
                    if (endDateMoment.hours() * 100 + endDateMoment.minutes() == 0) {
                        endDateMoment.subtract({days: -1});
                    }
                    let startMinutesValue = startDate.minutes() + startDate.hours() * 60;

                    // Ajout de la valeur sur la période
                    for (let i = 0; i < this.data.length; i++) {
                        if (this.data[i].ids.includes(value.DataId)) {
                            if (value.StartNoDay <= this.data[i].noDay && this.data[i].noDay <= value.EndNoDay) {
                                // Valeur à modifier
                                let dataFind = this.data[i].values.find(a => a.startData.id == value.DataId || a.endData.id == value.DataId);
                                if (dataFind != undefined) {
                                    dataFind.value = parseFloat(value.Value);
                                    dataFind.startData = {
                                        date: new Date(value.StartDate + "T" + value.StartTime),
                                        id: value.DataId,
                                        noDay: value.StartNoDay,
                                        noHour: value.StartNoHour,
                                        periodicity: value.Periodicity,
                                        value: parseFloat(value.Value)
                                    };
                                    dataFind.endData = {
                                        date: new Date(value.EndDate + "T" + value.EndTime),
                                        id: value.DataId,
                                        noDay: value.EndNoDay,
                                        noHour: value.EndNoHour,
                                        periodicity: value.Periodicity,
                                        value: parseFloat(value.Value)
                                    };
                                    dataFind.periodicity = value.Periodicity;
                                    dataFind = this.calculValue(dataFind, this.data[i].noDay);
                                }
                            } else {
                                // Valeur à supprimer
                                let dataFindIndex = this.data[i].values.findIndex(a => a.startData.id == value.DataId || a.endData.id == value.DataId);
                                this.data[i].values = this.data[i].values.slice(dataFindIndex, 1);
                            }
                        } else {
                            if (value.StartNoDay <= this.data[i].noDay && this.data[i].noDay <= value.EndNoDay) {
                                // Valeur à ajouter
                                this.data[i].ids.push(value.DataId);
                                this.data[i].values.push({
                                    endData: {
                                        date: endDate,
                                        id: value.DataId,
                                        noDay: endDateMoment.year() * 10000 + (endDateMoment.month() + 1) * 100 + endDateMoment.date(),
                                        noMonth: endDateMoment.year() * 100 + (endDateMoment.month() + 1),
                                        value: parseFloat(value.Value)
                                    },
                                    isFadeIn: 1,
                                    isFadeOut: 1,
                                    lenghtMinutesValue: 0,
                                    periodicity: value.Periodicity,
                                    startData: {
                                        date: startDate,
                                        id: value.DataId,
                                        noDay: startDateMoment.year() * 10000 + (startDateMoment.month() + 1) * 100 + startDateMoment.date(),
                                        noMonth: startDateMoment.year() * 100 + (startDateMoment.month() + 1),
                                        value: parseFloat(value.Value)
                                    },
                                    startMinutesValue: i == startDataIndex ? startMinutesValue : 0,
                                    unit: value.Unit,
                                    value: parseFloat(value.Value),
                                    valuePourcent: 0,
                                    nbPeriodValue: 1,
                                });
                                this.data[i].values[this.data[i].values.length - 1] =
                                    this.calculValue(this.data[i].values[this.data[i].values.length - 1], this.data[i].noDay);
                            }
                        }

                        if (this.data[i].values.length > 0) {
                            Vue.set(this.data, i, this.calculValueDay(this.data[i]));
                        }
                    }
                }
                break;
        }

        // Suppression des valeurs des jours contigus
        if (updateDatas) {
            if (this.calendarType == FactorCalendarTypeEnum.Semester) {
                let months = this.data.map(a => a.noMonth).filter((item, pos, self) => self.findIndex(v => v === item) === pos);
                for (let i = 0; i < months.length; i++) {
                    let monthValues = this.data.filter(a => a.noMonth === months[i]);
                    for (let d = 0; d < monthValues.length - 1; d++) {
                        if (monthValues[d].values.length > 0 && monthValues[d + 1].values.length > 0) {
                            let id = monthValues[d].values.map(a => a.startData.id);
                            id = id.concat(monthValues[d].values.map(a => a.endData.id));
                            let idNext = monthValues[d + 1].values.map(a => a.startData.id);
                            idNext = idNext.concat(monthValues[d + 1].values.map(a => a.endData.id));

                            let idIdems = idNext.filter(e => id.includes(e));

                            if (idIdems.length == id.length) {
                                monthValues[d + 1].value = undefined;
                                monthValues[d + 1].isFadeOut = 1;
                                monthValues[d + 1].isFadeIn = 1;
                            }
                        }
                    }
                }
            }
        }
        // Modification du statut du facteur.
        if (this.data.find(a => a.IsCalculate) || this.data.find(a => a.values.length > 0)) {
            this.FactorList[this.selectedFactor.Id].HasData = true;
        } else {
            this.FactorList[this.selectedFactor.Id].HasData = false;
        }

        return updateDatas;
    }

    /**
     * Traitement d'une valeur instantanée
     * @param value
     * @param startDataIndex
     * @private
     */
    private saveInstantValue(value, startDataIndex): boolean{
        let updateDatas = true;
        let startDate = this.getMomentDate(value.StartDate + ' ' + value.StartTime);
        let startMinutesValue = startDate.minutes() + startDate.hours() * 60;
        let findIndexData = this.data[startDataIndex].values.findIndex(a => a.startMinutesValue == startMinutesValue);

        switch (value.Status) {
            case -1:
                if (this.calendarType == FactorCalendarTypeEnum.Semester){
                    //let ids = this.data.map(a=> a.ids) -- à revoir ...
                    let valueInCalculate = this.data.filter(a=> a.ids.includes(value.DataId)).filter(a=> a.isCalculate);
                    if (valueInCalculate.length > 0){
                        updateDatas = false;
                        this.$bvToast.toast(this.$t('DeleteErrorMessage').toString(), { // $t('DeleteErrorMessage') / Il est impossible de supprimer la valeur en mode Semestre. Celle-ci est utilisée pour une valeur calculée. Veuillez sélectionner un autre mode d'affichage.
                            title: this.$t('UnableToModify').toString(), // $t('UnableToModify') / Modification impossible
                            autoHideDelay: 10000,
                            variant: "warning",
                            solid: true,
                            appendToast: true,
                            toaster: "b-toaster-top-center"
                        });
                    }
                }

                if (updateDatas) {
                    /* Recherche sur la date indiquée de la valeur en question */
                    let startValueIndex = this.data[startDataIndex].values.findIndex((a) => a.startData.id == value.DataId);
                    if (startValueIndex != -1){
                        /* Suppression de la valeur trouvée */
                        this.data[startDataIndex].values.splice(startValueIndex, 1);
                    }
                }
                break;
            case 0:
                // Vérification qu'une valeur n'est pas déjà existante sur ce jour.
                if (this.data[startDataIndex].isCalculate) {
                    updateDatas = false;
                    this.$bvToast.toast(this.$t('ChangeErrorMessage').toString(), { // $t('ChangeErrorMessage') / Il n'est pas possible de changer la valeur calculée d'un facteur d'influence en mode Semestre. Veuillez sélectionner un autre mode.
                        title: this.$t('UnableToModify').toString(), // $t('UnableToModify') / Modification impossible
                        autoHideDelay: 10000,
                        variant: "warning",
                        solid: true,
                        appendToast: true,
                        toaster: "b-toaster-top-center"
                    });
                }
                else if (this.data[startDataIndex].values.length > 1 && findIndexData > -1) {
                    updateDatas = false;
                    // Valeur trouvée - Message d'erreur
                    this.$bvToast.toast(this.$t('ValueAlreadyExist').toString() + // $t('ValueAlreadyExist') / Il existe déjà la valeur 
                        Intl.NumberFormat('fr-FR').format(this.data[startDataIndex].values[findIndexData].value) + " " +
                        this.selectedFactor?.Unit +
                        this.$t('Dated').toString() + startDate.format("DD/MM/YYYY HH:mm") + ". " + // $t('Dated') /  en date du / $t('DateHourFormat') / DD/MM/YYYY HH:mm
                        this.$t('TheValue').toString() + Intl.NumberFormat('fr-FR').format(value.Value) + " " + // $t('TheValue') / La valeur 
                        this.selectedFactor?.Unit + this.$t('HasNotBeenAdd').toString(), { // $t('HasNotBeenAdd') / " n'a pas pu être ajoutée."
                        title: this.$t('UnableToAddValue').toString(), // $t('UnableToAddValue') / "Ajout impossible la valeur sur le facteur d'influence"
                        autoHideDelay: 10000,
                        variant: "danger",
                        solid: true,
                        appendToast: true,
                        toaster: "b-toaster-top-center"
                    });
                } else {
                    this.data[startDataIndex].values.push({
                        endData: {
                            date: startDate,
                            id: -1,
                            noDay: startDate.date(),
                            noMonth: startDate.month() + 1,
                            value: parseFloat(value.Value)
                        },
                        isFadeIn: 1,
                        isFadeOut: 1,
                        lenghtMinutesValue: 0,
                        periodicity: value.Periodicity,
                        startData: {
                            date: startDate,
                            id: -1,
                            noDay: startDate.date(),
                            noMonth: startDate.month() + 1,
                            value: parseFloat(value.Value)
                        },
                        startMinutesValue: 0,
                        unit: value.Unit,
                        value: parseFloat(value.Value),
                        valuePourcent: 0,
                        nbPeriodValue: 1,
                    });
                    this.data[startDataIndex].values[this.data[startDataIndex].values.length - 1] =
                        this.calculValue(this.data[startDataIndex].values[this.data[startDataIndex].values.length - 1],
                            startDataIndex);
                    console.debug('FactorsEntering.vue - saveValue - ' +
                        'this.data[startDataIndex].values[this.data[startDataIndex].values.length - 1] : %O',
                        this.data[startDataIndex].values[this.data[startDataIndex].values.length - 1]);

                    if (this.data[startDataIndex].values.length > 0) {
                        this.data[startDataIndex] = this.calculValueDay(this.data[startDataIndex]);
                    }
                }
                break;
            case 1:
                /* Vérification qu'une valeur n'est pas déjà existante sur ce jour. */
                if (findIndexData > -1) {
                    if (this.data[startDataIndex].values[findIndexData].startData.id == value.DataId) {
                        // La valeur a juste été modifié
                        this.data[startDataIndex].values[findIndexData].value = parseFloat(value.Value);
                        this.data[startDataIndex].values[findIndexData].startData.value = parseFloat(value.Value);
                        this.data[startDataIndex].values[findIndexData].endData.value = parseFloat(value.Value);

                        this.data[startDataIndex].values[findIndexData] =
                            this.calculValue(this.data[startDataIndex].values[findIndexData], value.NoDay);
                    } else {
                        updateDatas = false;
                        // Valeur trouvée - Message d'erreur
                        this.$bvToast.toast(this.$t('ValueAlreadyExist').toString() + // $t('ValueAlreadyExist') / Il existe déjà la valeur 
                            Intl.NumberFormat('fr-FR').format(this.data[startDataIndex].values[findIndexData].value) + " " +
                            this.selectedFactor?.Unit +
                            this.$t('Dated').toString() + startDate.format("DD/MM/YYYY HH:mm") + ". " + // $t('Dated') /  en date du 
                            this.$t('TheValue').toString() + Intl.NumberFormat('fr-FR').format(value.Value) + " " + // $t('TheValue') / La valeur 
                            this.selectedFactor?.Unit + this.$t('HasNotBeenModify').toString(), { // $t('HasNotBeenModify') / " n'a pas pu être modifié."
                            title: this.$t('UnableToModifyValue').toString(), // $t('UnableToModifyValue') / "Modification impossible de la valeur sur le facteur d'influence",
                            autoHideDelay: 10000,
                            variant: "danger",
                            solid: true,
                            appendToast: true,
                            toaster: "b-toaster-top-center"
                        });
                    }
                } else {
                    // Changement de la valeur à date différente qui n'existe pas.
                    // Retrouver la date d'origine
                    let allValues = [...this.data?.flatMap(a => a.values).map(a => a.endData)];
                    allValues = allValues.concat([...this.data?.flatMap(a => a.values).map(a => a.startData)]);
                    findIndexData = allValues.findIndex(a => a.id == value.DataId);
                    console.debug('FactorsEntering.vue - saveValue - allValues : %O - findIndexData : %O', allValues, findIndexData);

                    // L'ajouter dans le bon jour.
                    this.data[startDataIndex].values.push({
                        endData: {
                            date: startDate,
                            id: value.DataId,
                            noDay: startDate.date(),
                            noMonth: startDate.month() + 1,
                            value: parseFloat(value.Value)
                        },
                        isFadeIn: 1,
                        isFadeOut: 1,
                        lenghtMinutesValue: 0,
                        periodicity: value.Periodicity,
                        startData: {
                            date: startDate,
                            id: value.DataId,
                            noDay: startDate.date(),
                            noMonth: startDate.month() + 1,
                            value: parseFloat(value.Value)
                        },
                        startMinutesValue: 0,
                        unit: value.Unit,
                        value: parseFloat(value.Value),
                        valuePourcent: 0,
                        nbPeriodValue: 1,
                    });
                    this.data[startDataIndex].values[this.data[startDataIndex].values.length - 1] =
                        this.calculValue(this.data[startDataIndex].values[this.data[startDataIndex].values.length - 1],
                            startDataIndex);
                    console.debug('FactorsEntering.vue - saveValue - ' +
                        'this.data[startDataIndex].values[this.data[startDataIndex].values.length - 1] : %O',
                        this.data[startDataIndex].values[this.data[startDataIndex].values.length - 1]);

                    // Supprimer cette valeur
                    let findIndexValue = this.data[allValues[findIndexData].noDay - 1].values.findIndex(a => a.startData.id == value.DataId);
                    this.data[allValues[findIndexData].noDay - 1].values.splice(findIndexValue, 1);
                    console.debug('FactorsEntering.vue - saveValue - findIndexValue : %O - ' +
                        'this.data[allValues[findIndexData].noDay].values : %O', findIndexValue,
                        this.data[allValues[findIndexData].noDay].values);
                }
                break;
        }

        // Suppression des valeurs des jours contigus
        if (updateDatas) {
            if (this.calendarType == FactorCalendarTypeEnum.Semester) {
                let months = this.data.map(a => a.noMonth).filter((item, pos, self) => self.findIndex(v => v === item) === pos);
                for (let i = 0; i < months.length; i++) {
                    let monthValues = this.data.filter(a => a.noMonth === months[i]);
                    for (let d = 0; d < monthValues.length - 1; d++) {
                        if (monthValues[d].values.length > 0 && monthValues[d + 1].values.length > 0) {
                            let id = monthValues[d].values.map(a => a.startData.id);
                            id = id.concat(monthValues[d].values.map(a => a.endData.id));
                            let idNext = monthValues[d + 1].values.map(a => a.startData.id);
                            idNext = idNext.concat(monthValues[d + 1].values.map(a => a.endData.id));

                            let idIdems = idNext.filter(e => id.includes(e));

                            if (idIdems.length == id.length) {
                                monthValues[d + 1].value = undefined;
                                monthValues[d + 1].isFadeOut = 1;
                                monthValues[d + 1].isFadeIn = 1;
                            }
                        }
                    }
                }
            }
        }
        // Modification du statut du facteur.
        if (this.data.find(a => a.IsCalculate) || this.data.find(a => a.values.length > 0)) {
            this.FactorList[this.selectedFactor.Id].HasData = true;
        } else {
            this.FactorList[this.selectedFactor.Id].HasData = false;
        }

        return updateDatas;
    }

    /**
     * Traitement d'une valeur indexée
     * @param value
     * @param startDataIndex
     * @private
     */
    private saveIndexedValue(value, startDataIndex): boolean{
        let updateDatas = true;
        let startDate = this.getMomentDate(value.StartDate + ' ' + value.StartTime);

        switch (value.Status) {
            case -1:
                /* Recherche de la période impactée par la suppresion de la valeur - dont la value est contenue (valeur de début et de fin) */
                let startValues: { noDay: number, index: number }[] = [];
                let endValues: { noDay: number, index: number }[] = [];
                for (let noDay = 0; noDay < this.data.length; noDay++) {
                    let startValueIndex = this.data[noDay].values.findIndex((a) => a.startData.id == value.DataId);
                    console.debug('FactorsEntering.vue - saveValue - Suppression de la valeur - Valeur indexée ' +
                        '- startValues : %O', this.data[noDay].values.filter((a) => a.startData.id == value.DataId));
                    if (startValueIndex != -1)
                        startValues.push({noDay: noDay, index: startValueIndex});
                }
                for (let noDay = 0; noDay < this.data.length; noDay++) {
                    let endValueIndex = this.data[noDay].values.findIndex((a) => a.endData.id == value.DataId);
                    console.debug('FactorsEntering.vue - saveValue - Suppression de la valeur - Valeur indexée ' +
                        '- endValues : %O', this.data[noDay].values.filter((a) => a.endData.id == value.DataId));
                    if (endValueIndex != -1)
                        endValues.push({noDay: noDay, index: endValueIndex});
                }

                let maxDay = Math.max(...startValues.map(a => a.noDay));
                let maxIndex = startValues.find(a => a.noDay == maxDay)?.index;
                let maxData = {...this.data[maxDay].values[maxIndex]};
                let minDay = Math.min(...endValues.map(a => a.noDay));
                let minIndex = endValues.find(a => a.noDay == minDay)?.index;
                let minData = {...this.data[minDay].values[minIndex]};

                /* Changement de la période de fin pour les dates trouvées */
                for (let end = 0; end < endValues.length; end++) {
                    this.data[endValues[end].noDay].values[endValues[end].index].endData = maxData.endData;
                    this.data[endValues[end].noDay].values[endValues[end].index] =
                        this.calculValue(this.data[endValues[end].noDay].values[endValues[end].index],
                            this.data[endValues[end].noDay].noDay);
                }
                /* Changement de la période de debut pour les dates trouvées */
                for (let start = 0; start < startValues.length; start++) {
                    this.data[startValues[start].noDay].values[startValues[start].index].startData = minData.startData;
                    this.data[startValues[start].noDay].values[startValues[start].index] =
                        this.calculValue(this.data[startValues[start].noDay].values[startValues[start].index],
                            this.data[startValues[start].noDay].noDay);
                }

                /** TODO : voir pour supprimer les valeurs en doubles maintenant ... */

                break;
            case 0:
                /** Vérification que la valeur est bien dans la période actuelle */
                let allValues: {
                    endDate: any, endNoDay: number, startDate: any, startNoDay: number,
                    startId: number, endId: number, noDay: number
                }[]
                    = [...this.data?.flatMap(({values, noDay}) => values.map(value => ({
                    ...value,
                    noDay: noDay
                })))
                    .map(a => ({
                        endDate: a.endData.date, endNoDay: undefined, startDate: a.startData.date,
                        startNoDay: undefined, startId: a.startData.id, endId: a.endData.id, noDay: a.noDay
                    }))];
                allValues.forEach(a => {
                    let startDate = this.getMomentDate(a.startDate);
                    a.startNoDay = startDate.year() * 100000000 + (startDate.month() + 1) * 1000000 + startDate.date() * 10000
                        + startDate.hours() * 100 + startDate.minutes();
                    let endDate = this.getMomentDate(a.endDate);
                    a.endNoDay = endDate.year() * 100000000 + (endDate.month() + 1) * 1000000 + endDate.date() * 10000
                        + endDate.hours() * 100 + endDate.minutes();

                    return a;
                });

                console.log('FactorsEntering.vue - saveChange - allValues : %O', allValues);

                let allDateOK = allValues;
                if (value.StartNoDay != 0) {
                    allDateOK = allDateOK.filter(a => a.startNoDay <= value.StartNoDay);
                }
                if (value.EndNoDay != 999912312359) {
                    allDateOK = allDateOK.filter(a => value.EndNoDay < a.endNoDay);
                }
                console.debug('FactorsEntering.vue - saveChange - allDateOK : %O', allDateOK);

                let findIndexAllDate = allDateOK.findIndex(a => a.startNoDay == value.StartNoDay ||
                    a.endNoDay == value.EndNoDay)

                if (findIndexAllDate > -1) {
                    updateDatas = false;
                    // Valeur trouvée - Message d'erreur
                    let findIndexData = this.data[allDateOK[findIndexAllDate].noDay - 1].values.findIndex(a => a.startData.id == allDateOK[findIndexAllDate].startId ||
                        a.endData.id == allDateOK[findIndexAllDate].endId);
                    this.$bvToast.toast(this.$t('ValueAlreadyExist').toString() + // $t('ValueAlreadyExist') / "Il existe déjà la valeur "
                        Intl.NumberFormat('fr-FR').format(this.data[allDateOK[findIndexAllDate].noDay - 1]
                            .values[findIndexData].value) + " " + this.selectedFactor?.Unit +
                        this.$t('Dated').toString() + startDate.format("DD/MM/YYYY HH:mm") + ". " + // $t('Dated') / " en date du " / $t('DateHourFormat') / DD/MM/YYYY HH:mm
                        this.$t('TheValue').toString() + Intl.NumberFormat('fr-FR').format(value.Value) + " " + // $t('TheValue').toString() / "La valeur "
                        this.selectedFactor?.Unit + this.$t('HasNotBeenAdd'), {// $t('HasNotBeenAdd') / n'a pas pu être ajoutée.
                        title: this.$t('UnableToAddValue').toString(), // $t('UnableToAddValue') / Ajout impossible de la valeur sur le facteur d'influence
                        autoHideDelay: 10000,
                        variant: "danger",
                        solid: true,
                        appendToast: true,
                        toaster: "b-toaster-top-center"
                    });
                } else {
                    // Ajout de la valeur sur une période
                    if (allDateOK.length == 0) {
                        // pas de valeur sur la période
                        if (this.outerData.length > 0) {
                            if (this.outerData[0].noMonth == value.NoMonth) {
                                /** La valeur est dans le même mois que la valeur déjà existante */

                            } else if (this.outerData[0].noMonth < value.NoMonth) {
                                /** La valeur est de date supérieure à la date déjà existante */
                                for (let i = 0; i < value.NoDay; i++) {
                                    this.data[i].values.push({
                                        startData: {...this.outerData[0]},
                                        endData: {
                                            noDay: value.NoDay,
                                            noMonth: value.NoMonth,
                                            id: -1,
                                            date: this.getMomentDate(value.StartDate + " " + value.StartTime)?.toDate(),
                                            value: value.Value
                                        },
                                        isFadeIn: 1,
                                        isFadeOut: 1,
                                        lenghtMinutesValue: 0,
                                        periodicity: value.Periodicity,
                                        startMinutesValue: 0,
                                        unit: value.Unit,
                                        value: parseFloat(value.Value),
                                        valuePourcent: 0,
                                        nbPeriodValue: 1,       // à revoir
                                    });
                                    this.data[i].values[this.data[i].values.length - 1] =
                                        this.calculValue(this.data[i].values[this.data[i].values.length - 1], i);
                                }
                                console.debug('FactorsEntering.vue - saveChange - ' +
                                    'La valeur est de date supérieure à la date déjà existante - this.data : %O - ' +
                                    'value.NoDay-1 : %O - this.data.length : %O', this.data,
                                    startDataIndex, this.data.length);
                            } else if (this.outerData[0].noMonth > value.NoMonth) {
                                /** La valeur est de date inférieure à la date déjà existante */
                                for (let i = startDataIndex; i < this.data.length; i++) {
                                    this.data[i].values.push({
                                        endData: {...this.outerData[0]},
                                        startData: {
                                            noDay: value.NoDay,
                                            noMonth: value.NoMonth,
                                            id: -1,
                                            date: this.getMomentDate(value.StartDate + " " + value.StartTime)?.toDate(),
                                            value: value.Value
                                        },
                                        isFadeIn: 1,
                                        isFadeOut: 1,
                                        lenghtMinutesValue: 0,
                                        periodicity: value.Periodicity,
                                        startMinutesValue: 0,
                                        unit: value.Unit,
                                        value: parseFloat(value.Value),
                                        valuePourcent: 0,
                                        nbPeriodValue: 1,               // à revoir...
                                    });
                                    this.data[i].values[this.data[i].values.length - 1] =
                                        this.calculValue(this.data[i].values[this.data[i].values.length - 1], i);
                                }
                                console.debug('FactorsEntering.vue - saveChange - ' +
                                    'La valeur est de date inférieure à la date déjà existante - this.data : %O', this.data);
                            }
                        } else {
                            this.outerData.push({
                                noDay: value.NoDay,
                                noMonth: value.NoMonth,
                                id: -1,
                                date: this.getMomentDate(value.StartDate + " " + value.StartTime)?.toDate(),
                                value: value.Value
                            });
                            console.debug('FactorsEntering.vue - saveChange - ' +
                                'Première valeurs - this.outerData : %O', this.outerData);
                        }
                    } else {
                        // Ajout de la valeur sur les périodes
                    }
                }
                break;
            case 1:
                break;
        }

        // Suppression des valeurs des jours contigus
        if (updateDatas) {
            if (this.calendarType == FactorCalendarTypeEnum.Semester) {
                let months = this.data.map(a => a.noMonth).filter((item, pos, self) => self.findIndex(v => v === item) === pos);
                for (let i = 0; i < months.length; i++) {
                    let monthValues = this.data.filter(a => a.noMonth === months[i]);
                    for (let d = 0; d < monthValues.length - 1; d++) {
                        if (monthValues[d].values.length > 0 && monthValues[d + 1].values.length > 0) {
                            let id = monthValues[d].values.map(a => a.startData.id);
                            id = id.concat(monthValues[d].values.map(a => a.endData.id));
                            let idNext = monthValues[d + 1].values.map(a => a.startData.id);
                            idNext = idNext.concat(monthValues[d + 1].values.map(a => a.endData.id));

                            let idIdems = idNext.filter(e => id.includes(e));

                            if (idIdems.length == id.length) {
                                monthValues[d + 1].value = undefined;
                                monthValues[d + 1].isFadeOut = 1;
                                monthValues[d + 1].isFadeIn = 1;
                            }
                        }
                    }
                }
            }
        }
        // Modification du statut du facteur.
        if (this.data.find(a => a.IsCalculate) || this.data.find(a => a.values.length > 0)) {
            this.FactorList[this.selectedFactor.Id].HasData = true;
        } else {
            this.FactorList[this.selectedFactor.Id].HasData = false;
        }

        return updateDatas;
    }

    /**
     * Permet de compléter les informations de la valeur pour cette date : recalcule des durées ...
     * @param value
     * @param noDay
     * @private
     */
    private calculValue(value, noDay): any {
        console.debug('FactorsEntering.vue - calculValue - value : %O - noDay : %O', value, noDay);
        if (value.startDate != value.endDate)
            value.value = value.endData.value - value.startData.value;

        moment.locale('fr');

        /** Recalcule des durées */
        let startDate = this.getMomentDate(value.startData.date);
        let endDate = this.getMomentDate(value.endData.date);
        let startPeriod = this.getNumberToDate(noDay, 'day');
        let endPeriod = startDate.clone().add({days: 1});
        let lenghtPeriod = 1440;
        if (this.calendarType == FactorCalendarTypeEnum.Day || this.calendarType == FactorCalendarTypeEnum.Week) {
            endPeriod = startDate.clone().add({hours: 1});
            lenghtPeriod = 60;
        }

        if (startDate.diff(startPeriod, 'minutes') < 0)
            value.startMinutesValue = 0 /* La date de début est inférieure à la date de la période */
        else
            value.startMinutesValue = startDate.diff(startPeriod, 'minutes'); /* La valeur est sur la même période */

        if (startDate >= startPeriod)/* La valeur est sur la même période */{
            let end = endDate > endPeriod ? endPeriod : endDate;
            value.lenghtMinutesValue = end.diff(startDate, 'minutes');
        } else {
            if (endDate > endPeriod) {
                value.lenghtMinutesValue = lenghtPeriod - value.startMinutesValue;  /* Le nombre de minutes restantes dans la période */
            } else {
                value.lenghtMinutesValue = endDate.diff(startPeriod, 'minutes'); /* Différence entre le debut de la journée et la fin de la période */
            }
        }

        let minPeriod = startPeriod;
        let maxPeriod = endPeriod;
        switch (this.calendarType) {
            case FactorCalendarTypeEnum.Day:
                minPeriod = moment([startPeriod.year(), startPeriod.month(), startPeriod.date(), startPeriod.hour()]);
                maxPeriod = minPeriod.clone().add({hour: 1});
                break;
            case FactorCalendarTypeEnum.Week:
                minPeriod = startPeriod.clone().startOf('week');
                maxPeriod = startPeriod.clone().add({days: 7});
                break;
            case FactorCalendarTypeEnum.Month:
                minPeriod = moment([startPeriod.year(), startPeriod.month(), startPeriod.date()]);
                maxPeriod = minPeriod.clone().add({days: 1});
                break;
            case FactorCalendarTypeEnum.Semester:
                minPeriod = moment([startPeriod.year(), startPeriod.month(), 1]);
                maxPeriod = minPeriod.clone().add({months: 1}).subtract({days: 1});
                break;
        }
        value.isFadeIn = startDate <= minPeriod ? 0 : 1; // fin du mois
        value.isFadeOut = endDate >= maxPeriod ? 0 : 1;  // debut de mois

        console.debug('FactorsEntering.vue - calculValue - value : %O', value);
        return value;
    }

    /**
     * Re-calcul les valeurs du jour/heure
     * @param day
     * @private
     */
    private calculValueDay(day): any{
        // Recalcule
        if (day.values.length == 1) {
            /* Calcul de la durée de la valeur sur une période d'un mois. */
            let startDate = this.getNumberToDate(day.noDay, 'day').toDate();
            let startDateMoment = moment(startDate);
            let endDateMoment = moment(startDateMoment.year() + '-' + (startDateMoment.month() + 1 /* les mois commencent à 0. */) + '-01');
            endDateMoment.add({months: 1});
            let endNoDay = endDateMoment.year() * 10000 + (endDateMoment.month() + 1) * 100 + endDateMoment.date();
            if (day.noDay < day.values[0].startData.noDay) {
                startDate = new Date(day.values[0].startData.date);
                startDateMoment = moment(startDate);
            }
            if (endNoDay > day.values[0].endData.noDay) {
                let endDate = new Date(day.values[0].endData.date);
                endDateMoment = moment(endDate);
            }
            day.nbPeriodValue = endDateMoment.diff(startDateMoment, 'days');
            if (endDateMoment.hours() * 100 + endDateMoment.minutes() > 0) {
                day.nbPeriodValue = day.nbPeriodValue + 1;
            }

            day.value = day.values[0].value;
            day.periodicity = day.values[0].periodicity;
            day.isFadeOut = day.values[0].isFadeOut;
            day.isFadeIn = day.values[0].isFadeIn;
            day.maxValue = day.values[0].value;
            day.minValue = day.values[0].value;
        } else {
            let valueDay = undefined;
            if ((this.selectedFactor as any).FactorType == 1) { //Combinable = 1
                let startPeriod: moment.Moment = this.getNumberToDate(day.noDay, 'day');
                let endPeriod = startPeriod.clone();
                if (this.data[0].noHour != 0)
                    endPeriod = endPeriod.add({hour: 1});
                else
                    endPeriod = endPeriod.add({day: 1});
                console.debug('FactorsEntering.vue - calculValueDay - startPeriod : %O, endPeriod : %O',
                    startPeriod, endPeriod);

                valueDay = day.values.map(a =>
                    startPeriod >= a.startData.date && endPeriod <= a.endData.date ?
                        a.value / a.startData.date.diff(a.endData.date, 'minutes') * startPeriod.diff(endPeriod, 'minutes') :
                        (startPeriod >= a.startData.date && endPeriod > a.endData.date ?
                                a.value / a.startData.date.diff(a.endData.date, 'minutes') * startPeriod.diff(a.endData.date, 'minutes') :
                                (startPeriod < a.startData.date && endPeriod <= a.endData.date ?
                                    a.value / a.startData.date.diff(a.endData.date, 'minutes') * a.startData.date.diff(endPeriod, 'minutes') :
                                    a.value)
                        )
                ).reduce((a, b) => a + b, 0);

            } else if ((this.selectedFactor as any).FactorType == 2 &&
                (this.selectedFactor as any).Temporality != 2) { //Average = 2
                valueDay = day.values.map(a => a.value * this.getMomentDate(a.startData.date)?.diff(this.getMomentDate(a.endData.date), 'minutes')
                ).reduce((a, b) => a + b, 0) /
                    moment().min(day.values.map(a => this.getMomentDate(a.startData.date)))?.diff(
                        moment().max(day.values.map(a => this.getMomentDate(a.endData.date))));

            } else if ((this.selectedFactor as any).FactorType == 2
                && (this.selectedFactor as any).Temporality == 2) { //Average = 2
                valueDay = day.values.map(a => a.value).reduce((a, b) => a + b, 0) /
                    day.values.length;

            }
            day.value = valueDay;
            day.isCalculate = true;
            day.periodicity = day.values[0].periodicity;
            day.isFadeOut = day.values[0].isFadeOut;
            day.isFadeIn = day.values[0].isFadeIn;
            day.nbPeriodValue = day.values[0].nbPeriodValue;

            day.maxValue = Math.max(...day.values.map(a=> a.value));
            day.minValue = Math.min(...day.values.map(a=> a.value));
        }
        console.debug('FactorsEntering.vue - calculValueDay - day : %O', day);
        return day;
    }

    /**
     * Changement de sélection du facteur d'influence
     * @param factor
     */
    public changeFactor(factor: number) {
        console.debug('FactorsEntering.vue - changeFactor', factor);
        this.selectedFactor = {...this.FactorList[factor], Id: factor};
        console.debug('FactorsEntering.vue - changeFactor - selectedFactor : %O', this.selectedFactor);
    }

    /**
     * Enregistrement des données des facteurs dans la partie Administration
     * @private
     */
    private save() {
        // écran de chargement
        this.$store.dispatch("ShowLoadingMask", this.$t('LoadingInProgress').toString()); // $t('LoadingInProgress') / Chargement en cours...

        // Enregistrement du facteur
        const args: Dictionary<any> = {};
        args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
        let factorValues = {};
        let factorsId = Object.keys(this.FactorList);
        for (let i=0; i <factorsId.length; i++) {
            factorValues[factorsId[i]] = this.FactorList[factorsId[i]].Value;
        }
        args["Factors"] = factorValues;

        axios.post(API_URL + "Factors/SaveData", args).then((response) => {
            if (response && response.data) {
                console.debug('FactorsEntering.vue - save', response);
                for (let i = 0; i < factorsId.length; i++) {
                    this.FactorList[factorsId[i]].Value = [];
                }
                this.haveToSave = false;
                this.showDatas = [];

                this.getFactorData(this.selectedFactor, this.selectedDate, this.calendarType, this.NodeId);
                console.debug('FactorsEntering.vue - save', response);
                this.$store.dispatch("HideLoadingMask", {});
            }
        }).catch(err => {
            console.error(err);
            this.$store.dispatch("HideLoadingMask", {}).then(() => {
                this.$bvToast.toast(this.$t('ErrorWhileSaving').toString(), { // $t('ErrorWhileSaving') / "Une erreur s'est produite lors de l'enregistrement du facteur"
                    title: this.$t('Error').toString(), // $t('Error') / "Erreur"
                    autoHideDelay: 10000,
                    variant: "danger",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });
            });
        });
    }

    /**
     *  Récupération des données du facteur suivant un type de calendrier et de la date sélectionnée
     * @param selectedFactor
     * @param selectedDate
     * @param calendarType
     * @param NodeId
     * @private
     */
    private getFactorData(selectedFactor?: any, selectedDate?: Date, calendarType?: FactorCalendarTypeEnum, NodeId?: String) {
        console.debug('FactorsEntering.vue - getFactorData');
        // écran de chargement
        this.$store.dispatch("ShowLoadingMask", this.$t('LoadingInProgress').toString()); // $t('LoadingInProgress') / Chargement en cours...

        if(this.selectedFactor == undefined || this.selectedFactor == null){
            this.refreshFactorList();
        }

        this.data = [];
        console.debug('FactorsEntering.vue - Recherche des données pour le facteur', selectedFactor, selectedDate,
            calendarType, NodeId);
        if (this.createdPage && selectedDate != undefined && calendarType) {
            // Chargement des données du facteur
            const args: Dictionary<any> = {};
            args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
            args["FactorId"] = selectedFactor?.Id;
            args["Date"] = typeof selectedDate == 'string' ? moment(selectedDate).utc().format() : selectedDate;
            args["CalendarType"] = calendarType;
            args["NodeId"] = NodeId;
            if(selectedFactor != undefined && selectedFactor != null && this.FactorList != null && (selectedFactor?.Id in this.FactorList))
                args["FactorModifDatas"] = this.FactorList[selectedFactor.Id]?.Value;
            console.debug("FactorsEntering.vue - LoadData - args", args);

            axios.post(API_URL + "Factors/LoadData", args).then((response) => {
                if (response && response.data) {
                    console.debug("FactorsEntering.vue - LoadData - response.data.Results", response.data.Results);

                    this.data = response.data.Results.factorData._steps;
                    this.outerData = response.data.Results.factorData._outerDatas;
                    if (this.data == undefined)
                        this.data = [];

                    /** Re-affichage de la valeur minimum et maximum */
                    let minMax = this.getMinMax({data: this.data, outerData: this.outerData}, this.startPeriod, this.endPeriod);
                    this.minValue = minMax.min;
                    this.maxValue = minMax.max;

                    /** Ré-affichage de la période */
                    this.labelSelectedDate = this.getSelectedDate(this.calendarType, this.startPeriod, this.endPeriod);

                    console.debug('FactorsEntering.vue - LoadData - data', this.data);
                }
                this.$store.dispatch("HideLoadingMask", {})
            }).catch(err => {
                console.error(err);
                this.$store.dispatch("HideLoadingMask", {}).then(() => {
                    this.$bvToast.toast(this.$t('ErrorWhileSaving').toString(), { // $t('ErrorWhileSaving') / "Une erreur s'est produite lors du chargement du facteur"
                        title: this.$t('Error').toString(), // $t('Error') / Erreur
                        autoHideDelay: 10000,
                        variant: "danger",
                        solid: true,
                        appendToast: true,
                        toaster: "b-toaster-top-center"
                    });
                });
            });
        }
    }

    //#endregion - Données des facteurs
}
</script>

<style scoped>

</style>